// Informacion que se muestra al final de la pantalla "Acerca de" (el boton "i" del encabezado).
// Para agregar datos del sistema (contacto de soporte, area responsable, notas...) basta con
// escribirlos aqui, uno por renglon, y publicar una nueva version. Si la lista esta vacia,
// la seccion no aparece.
//
// Ejemplo:
//   { titulo: "Soporte", texto: "Texto que se mostrara a los usuarios" },
export const INFORMACION_ADICIONAL = [];
